import react from "../images/react.png";
import python from "../images/python.png";
import bs from "../images/bootstrap.png";
import django from "../images/django.png";
import node from "../images/nod.png";
import tailwind from "../images/tailwind.png";

import pestbytes from "../images/pestbytes.png";
import ghf from "../images/ghf.png";
import portfolio from "../images/portfolio.png";
import cbdp from "../images/cbdp1.png";
import pms from "../images/pms.png";
import report from "../images/report.png";

export const language = [
  {
    id: 1,
    img: bs,
    name: "Bootstrap",
  },
  {
    id: 2,
    img: node,
    name: "Node JS",
  },
  {
    id: 3,
    img: react,
    name: "React JS",
  },
  {
    id: 4,
    img: django,
    name: "Django",
  },
  {
    id: 5,
    img: python,
    name: "Python",
  },
  {
    id: 6,
    img: tailwind,
    name: "Tailwind",
  },
];

export const projects = [
  {
    id: 1,
    img: pestbytes,
    title: "Pestbytes",
    description:
      "Pestbytes is MERN stack multi-user responsive web app for pest blogging community. It is india's first pest blogging portal, which is one stop solution for all your pest problems. Here you can find most interesting case studies on pest, product reviews, publications from academia and many more.",
    website: "https://pestbytes.com",
    github: "https://github.com/mayurkanade44/Pestbytes",
  },
  {
    id: 2,
    img: pms,
    title: "PMS Contract",
    description:
      "The PMS Cloud is MERN stack web app, used by Pest Management & Services to create a pest control contract and service cards for clients. Each service card has unique QR code, which helps service operator to quickly & easily update the status after the service.",
    website: "https://www.thepmscloud.com/",
    github: "https://github.com/mayurkanade44/PMS-Contract",
  },
  {
    id: 3,
    img: cbdp,
    title: "CBDP",
    description:
      "CBDP is Cloud Based Documents Portal made with React & Noede js. It is used by Express Pesticides Pvt Ltd for sending MSDS, SOP & Technical Documents of various pest services to clients with inbuilt emailing function. Also user can download work done pest control service card.",
    website: "http://cbdp.sat9.in/",
    github: "https://github.com/mayurkanade44/CBDP-SAT",
  },
  {
    id: 6,
    img: report,
    title: "Reports Portal",
    description:
      "Report portal made with MERN stack to generate various pest related predefined reports like RIM(Rodent Management), Work Done/Not Done, Pest Inspection etc. Also it has approval process where back office person can download and approve the before sending it to client with inbuilt email functionality",
    website: "https://report.sat9.in/",
    github: "https://github.com/mayurkanade44/Reports",
  },
  {
    id: 4,
    img: ghf,
    title: "Giving Hope Foundation",
    description:
      "GHF is made with react. It is a registered trust founded by CEO of Express Pesticides. Foundation is working unbiasedly, focusing to deliver hope to all endeavors leading to improve sustainability and quality of life. ",
    website: "https://ghf.sat9.in/",
    github: "https://github.com/mayurkanade44/ghf",
  },
  {
    id: 5,
    img: portfolio,
    title: "Portfolio",
    description:
      "React based full responsive portfolio. Used Bootstrap 5 for CSS, it has multiple pages routed through React-Router-6.",
    website: "https://github.com/",
    github: "https://github.com/mayurkanade44/Portfolio-v2",
  },
];
